query AvailablePurchaseOrders($invoiceId: UUID!) {
  availablePurchaseOrders(
    invoiceId: $invoiceId
    orderBy: INDEX_REFERENCE_NUMBER_ASC
  ) {
    nodes {
      id
      indexReferenceNumber
      indexName
      documentAppliedAmount
      documentOverageAmount
      currency {
        isoCode
      }
    }
  }
}
